class DocumentationPathLms {

    constructor() {

        this._testPassed = null;
        this._testScore = null;
        this._progress = 0;
        this._completed = false;
        this._totalTime = "";

    }

    blockPathExit() {

        // Eliminar zonas de la app que no deben ser accesibles por el usuario desde LMS
        const $docDetailsPath = $("div.doc-details-PATH");
        const $exitPathMenuButton = $("section.singlemenu");
        const $documentationSection = $("#documentationSection");

        if ($docDetailsPath.length > 0) {
            $exitPathMenuButton.hide();
        }

        $documentationSection.remove();

    }

    setData(pathData) {

        const documentationProgress = documentationScreenController.documentationProgress;

        this._totalTime = user.total_time;
        this._completed = pathData.progressState.state === documentationProgress.COMPLETED;
        this._progress = pathData.progressState.percentage / 100;

        if (pathData.test.enabled && pathData.test.document.own_test.best_game) {

            this._testPassed = pathData.test.document.own_test.best_game.qualification >= pathData.test.document.own_test.minimum_qualification;
            this._testScore = pathData.test.document.own_test.best_game.qualification;

        }

    }

    sendPathProgress(pathData) {

        let lmsPathProgress = {
            msj: "progress",
            result: {
                user: {
                    total_time: this._totalTime,
                    path_progress: this._progress,
                    path_completed: this._completed
                }
            }
        };

        if (pathData.test.enabled && (this._testPassed || pathData.test.document.own_test.games.length === pathData.test.document.own_test.maximum_tries)) {
            lmsPathProgress.result.user.test_passed = this._testPassed,
            lmsPathProgress.result.user.test_score = this._testScore;
        }

        window.parent.postMessage(lmsPathProgress, "*");

    }

}